<ng-container [formGroup]="parent">
  <div [formGroupName]="formgroupName">
    <h3 [hidden]="hiddenHeadingStatus">Address Information</h3>
    <div class="form-group has-float-label mb-2">
      <label class="form-label" for="countryRegionIdD365"
        >Country/Region<span class="madatory-field">*</span></label
      >
      <p-select
        [(ngModel)]="countryRegionSelectedId"
        formControlName="countryRegionIdD365"
        [ngClass]="{ 'has-error': formErrors['countryRegionIdD365'] }"
        [options]="countryRegionList"
        [showClear]="true"
        [filter]="true"
        optionLabel="countryRegionD365"
        optionValue="countryRegionD365"
        (onBlur)="logValidationErrors()"
        (onChange)="onCountryRegionSelection($event.value)">
      </p-select>

      <span class="error-msg" *ngIf="formErrors['countryRegionIdD365']">
        {{ formErrors["countryRegionIdD365"] }}
      </span>
    </div>

    <div
      class="form-group has-float-label mb-2 address-lookup"
      [hidden]="showAddress">
      <label class="form-label" for="melissa">Address Lookup</label>

      <p-autoComplete
        [(ngModel)]="melissa"
        [suggestions]="melissaSearchResult"
        (completeMethod)="searchMelissaAutoComplete($event)"
        [forceSelection]="false"
        [dropdown]="false"
        (onSelect)="selectedStreet($event)"
        (onChange)="enableAndDisabledValidateButton()"
        placeholder="Enter address"
        formControlName="addressFormat">
        <ng-template let-address #item>
          {{ melissaFormatter(address) }}
        </ng-template>
      </p-autoComplete>
    </div>

    <div class="form-group has-float-label mb-4" *ngIf="isFromAddClient">
      <span class="error-msg" *ngIf="formErrors['billingAttention']">
        {{ formErrors["billingAttention"] }}
      </span>
      <label class="form-label" for="billingAttention">Attention</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="billingAttention"
        name="billingAttention"
        placeholder=""
        formControlName="billingAttention"
        [maxlength]="30"
        [ngClass]="{ 'has-error': formErrors['billingAttention'] }"
        (blur)="logValidationErrors()" />
    </div>
    <div class="form-group has-float-label mb-4" *ngIf="isFromAddClient">
      <label class="form-label" for="billingLocation">Location</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="billingLocation"
        name="billingLocation"
        placeholder=""
        [maxlength]="30"
        formControlName="billingLocation"
        (blur)="logValidationErrors()" />

      <span class="error-msg" *ngIf="formErrors['billingLocation']">
        {{ formErrors["billingLocation"] }}
      </span>
    </div>

    <div [hidden]="appartmentFieldStatus">
      <div
        class="form-group has-float-label mb-2"
        *ngIf="appartmentList.length">
        <label class="form-label" for="selectedAppartment"
          >Suite Selection Box</label
        >
        <p-select
          [(ngModel)]="selectedAppartment"
          formControlName="buildingComplimentD365"
          (onChange)="onAppartmentSelection($event)"
          [ngClass]="{ 'has-error': !appartmentFieldStatus }"
          #selector
          [options]="appartmentList">
        </p-select>
      </div>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="addressFormat"
        >Address Line 1<span class="madatory-field">*</span></label
      >
      <p-autoComplete
        [(ngModel)]="melissaForNonUsAddress1"
        [suggestions]="melissaNonUsSearchResult"
        (completeMethod)="searchMelissaNonUsAutoComplete($event)"
        [forceSelection]="false"
        [dropdown]="false"
        (onSelect)="selectedStreetForNonUs($event)"
        (onChange)="enableAndDisabledValidateButton()"
        placeholder="Enter address"
        formControlName="addressFormat"
        appendTo="body"
        [optionLabel]="'Address.Address'">
        <ng-template let-addressnonus #item>
          {{ melissaFormatterNonUs(addressnonus) }}
        </ng-template>
      </p-autoComplete>
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="addressLine2">Address Line 2</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        formControlName="addressLine2"
        [(ngModel)]="address2" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="addressLine3">Address Line 3</label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="addressFormat"
        name="addressFormat"
        placeholder=""
        formControlName="addressLine3"
        [(ngModel)]="address3" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="cityD365"
        >City/Locality<span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="cityD365"
        name="cityD365"
        placeholder=""
        formControlName="cityD365"
        [(ngModel)]="city"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="stateD365"
        >State/Province<span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="stateD365"
        name="stateD365"
        placeholder=""
        formControlName="stateD365"
        [(ngModel)]="state"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="zipCodeD365"
        >Postal Code<span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="zipCodeD365"
        name="zipCodeD365"
        placeholder=""
        formControlName="zipCodeD365"
        [(ngModel)]="postalcode"
        (change)="enableAndDisabledValidateButton()" />
    </div>
    <div
      class="form-group has-float-label mb-2"
      [hidden]="nonUsandCadFieldStatus">
      <label class="form-label" for="streetD365"
        >Street<span class="madatory-field">*</span></label
      >
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="streetD365"
        name="streetD365"
        placeholder=""
        formControlName="streetD365" />
    </div>

    <div class="form-group has-float-label mb-2">
      <label class="form-label" for="c_name">Address</label>
      <textarea
        jniAutoCompleteBlocker
        formControlName="addressD365"
        pInputText
        rows="3"
        (change)="formattedAddressChange()"
        [ngClass]="{ 'has-error': isAddressError }"></textarea>

      <span class="error-msg" *ngIf="isAddressError">
        Address is not valid
      </span>
    </div>

    <div class="form-group has-float-label mb-4" *ngIf="isFromClient">
      <label class="form-label" for="addressLocationNameD365"
        >Name <span></span
      ></label>
      <input
        jniAutoCompleteBlocker
        type="text"
        pInputText
        id="addressLocationNameD365"
        name="addressLocationNameD365"
        placeholder=""
        formControlName="addressLocationNameD365" />
    </div>

    <div *ngIf="isFromClient" class="form-group has-float-label mb-2">
      <label class="form-label" for="purposeD365">Purpose <span></span></label>
      <p-select
        [(ngModel)]="purposeTypeSelectedId"
        formControlName="purposeD365"
        [ngClass]="{ 'has-error': formErrors['countryRegionIdD365'] }"
        [options]="purposeTypes"
        optionLabel="name"
        optionValue="value"
        [showClear]="false">
      </p-select>
    </div>

    <div
      class="form-group has-float-label mb-2"
      [hidden]="isPrimaryFieldStatus">
      <div class="switcher">
        <label class="form-label mb-1">Primary:</label>
        <div class="d-flex align-items-center form-switch">
          <p-toggleswitch
            name="rcCheck"
            type="checkbox"
            id="rcCheck"
            formControlName="isPrimaryD365" />
          <!-- <label class="form-check-label" for="rcCheck">{{
            this.parent.get(['addressInformation', 'isPrimaryD365'])?.value
          }}</label> -->
        </div>
      </div>
    </div>

    <div class="form-group has-float-label mb-4" [hidden]="true">
      <label class="form-label" for="c_name">validateAddress</label>
      <input
        jniAutoCompleteBlocker
        pInputText
        type="text"
        formControlName="validateAddress"
        style="height: 120px" />
    </div>
    <div class="col mb-4 d-flex align-items-center justify-content-end">
      <div class="form-group has-float-label">
        <!-- <button
          type="button"
          style="margin-left: 10px"
          (click)="validateAddress(true)"
          [hidden]="hideValidateButton"
          class="btn validate"
          [ngClass]="{
            'btn-success': addressValidationStatus === false,
            'btn-primary': addressValidationStatus === true,
            'btn-danger': isAddressError === true,
          }">
          Validate address
        </button> -->

        <p-button
          label="Validate address"
          (click)="validateAddress(true)"
          [hidden]="hideValidateButton"
          class="btn validate"
          [severity]="
            isAddressError
              ? 'danger'
              : addressValidationStatus === true
                ? 'primary'
                : addressValidationStatus === false
                  ? 'success'
                  : 'secondary'
          " />
      </div>
    </div>
  </div>
</ng-container>
